import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import map from 'lodash/map';

import { formatCurrency } from 'pages/MyAccount/utils/currency';
import styles from '../Section.module.css';
import creditStyles from './Credits.module.css';

const CREDITS_DATA_TIP = `Your available credits are detailed below. For additional information on credits, please 
  <a href='https://support.fabfitfun.com/hc/en-us/articles/360035608832-How-does-credit-work-#how-does-credit-work--0-0'
  target='_blank'>click here</a>.`;

const Credits = ({ credits }) => {
  if (!credits) return null;

  return (
    <>
      <div data-testid="credits-discount-section">
        <div className={`${styles.header} ${styles.headerLeft}`}>
          <span>Credits & Discounts</span>
          <i
            className="fas fa-info-circle"
            data-tip={CREDITS_DATA_TIP}
            data-for="credits"
            data-delay-hide="2000"
          />
        </div>
        <div
          className={`${styles.readOnlyContainer} ${creditStyles.container}`}
        >
          <ul>
            {map(credits, (credit) => {
              const { creditName, amount } = credit;
              return (
                <li key={creditName} className={creditStyles.item}>
                  <span>{`${creditName}: `}</span>
                  {formatCurrency(amount / 100)}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      <ReactTooltip
        id="credits"
        className={creditStyles.tooltip}
        place="top"
        type="dark"
        effect="solid"
        globalEventOff="click"
        html
      />
    </>
  );
};

Credits.propTypes = {
  credits: PropTypes.arrayOf(PropTypes.shape({})),
};

Credits.defaultProps = {
  credits: null,
};

export default Credits;
